import { render, staticRenderFns } from "./VendorListAddNew.vue?vue&type=template&id=f887471e"
import script from "./VendorListAddNew.vue?vue&type=script&lang=js"
export * from "./VendorListAddNew.vue?vue&type=script&lang=js"
import style0 from "./VendorListAddNew.vue?vue&type=style&index=0&id=f887471e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports